import React from "react";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as Back } from "../../../../../assets/svgs/back-button.svg";
import LineAndColumnGraph from "../common/LineAndColumnGraph";
import LineChart from "../common/LineChart";
import SimplePieChart from "../common/SimplePieChart";
import TwoColumnBarGraph from "../common/MultipleColumnBarGraph";
import WorkforceBarChart from "../common/WorkforceBarChart";
import ColumnWithNegativeVal from "../common/ColumnWithNegativeVal";
import VerticalBarChart from "../common/VerticalBarChart";
import ReactApexChart from "react-apexcharts";
import EmployementEngagement from "./EmployementEngagement";
import LocalEmpowerMent from "./LocalEmpowerMent";
import HealthAndSafetty from "./HealthAndSafetty";
import EmployeeWellBeing from "./EmployeeWellBeing";

import { ReactComponent as EmployeeTurnoverRateImage } from "../../../../../assets/svgs/EmployeeTurnoverRates.svg";
import { ReactComponent as RetentionRateImage } from "../../../../../assets/svgs/RetentionRates.svg";
import { ReactComponent as ChangeInManPowerImage } from "../../../../../assets/svgs/ChangeInManPowers.svg";
import { ReactComponent as TrainingAndDevelopImage } from "../../../../../assets/svgs/TrainingAndDevelops.svg";
import { ReactComponent as DiversityImage } from "../../../../../assets/svgs/Diversitys.svg";
import { ReactComponent as GenderPayEquityImage } from "../../../../../assets/svgs/GenderPayEquitys.svg";
import { ReactComponent as EmpWorkContractImage } from "../../../../../assets/svgs/EmpWorkContracts.svg";
import { ReactComponent as PermVSTempEmpImage } from "../../../../../assets/svgs/PermVSTempEmps.svg";
import { ReactComponent as TitleIcon } from "../../../../../assets/svgs/TitlesIcon.svg";
import { ReactComponent as IncidentReducedImage } from "../../../../../assets/svgs/IncidentReduceds.svg";
import { THEME_COLORS } from "../../../../../color";
import { useNavigate } from "react-router-dom";
import TimeFilterBar from "../TimeFilterBar";
import CarbonCard from "../common/CarbonCard";
import { ReactComponent as Env1 } from "../../../../../assets/svgs/soEnv1.svg";
import { ReactComponent as Env2 } from "../../../../../assets/svgs/soEnv2.svg";
import { ReactComponent as Env3 } from "../../../../../assets/svgs/soEnv3.svg";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import PermissionForm from "../../../../Auth/PermissionForm";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";

const Social = ({ categories = [], showLegends }) => {
  const columnColors = ["#06513D", "#0288A4", "#50ADBF", "#289BAF", "#0087A3"];
  const navigate = useNavigate();
  const [showPermission, setPermission] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [activeDashboard, setActiveDashboard] = useState(() => {
    return sessionStorage.getItem("hideDummy") === "true" ? "live" : "dummy";
  });
  const [loading, setLoading] = useState(() => {
    return sessionStorage.getItem("hideDummy") === "true";
  });
  const { user, selectedGroupMember } = useSelector((state) => state.auth);
  const [yearFilter, setYearFilter] = useState(() =>
    user?.reportingYearType === "calendar" ? "2026" : "2026-2027",
  );
  const isPermissionCompleted = user?.isCompleted;

  const selectedMemberId =
    selectedGroupMember === "string"
      ? selectedGroupMember
      : selectedGroupMember?.clientId ||
        selectedGroupMember?._id ||
        selectedGroupMember?.client_id?._id ||
        selectedGroupMember?.client_id;

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (activeDashboard !== "live") {
        setLoading(false);
        setDashboardData(null);
        return;
      }

      try {
        setLoading(true);
        let apiUrl;

        if (selectedMemberId) {
          apiUrl = API_URLS.GET_GROUP_MEMBER_DASHBOARD(
            "social",
            selectedMemberId,
          );
        } else {
          apiUrl = API_URLS.GET_SDG_DASHBOARD("social");
        }

        const queryParams = new URLSearchParams();
        if (yearFilter) queryParams.append("year", yearFilter);
        const queryString = queryParams.toString()
          ? `?${queryParams.toString()}`
          : "";
        apiUrl += queryString;

        console.log("Social Dashboard API Hit:", apiUrl);
        const res = await getApi({
          apiUrl: apiUrl,
        });
        console.log("Social Dashboard Response:", res);
        if (res?.data) {
          const data = res.data.dashboard ? res.data.dashboard : res.data;
          setDashboardData(data);
        }
      } catch (error) {
        console.error("Error fetching Social dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, [selectedMemberId, activeDashboard, yearFilter]);

  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  const getComponent = (id) =>
    activeDashboard === "live"
      ? dashboardData?.components?.find((c) => c.componentId === id)
      : null;

  // 1. Local Communities
  const localCommComp = getComponent("soc_local_communities");
  const localCommValue =
    activeDashboard === "live"
      ? localCommComp?.data?.total !== undefined
        ? `${localCommComp.data.total}% `
        : "0% "
      : "65%";

  // 2. Local Suppliers
  const localSuppComp = getComponent("soc_local_suppliers");
  const localSuppValue =
    activeDashboard === "live"
      ? localSuppComp?.data?.percentageChange !== undefined
        ? `${localSuppComp.data.percentageChange}% `
        : "0% "
      : "  18% ";

  // 3. Local Economic Empowerment
  const localEmpowerComp = getComponent("soc_local_economic_empowerment");
  const localEmpowerValue =
    activeDashboard === "live"
      ? localEmpowerComp?.data?.value !== undefined
        ? `${localEmpowerComp.data.value.toLocaleString()} %`
        : "0 %"
      : "1.5 %";

  const getTurnoverValue = (yearObj) => {
    if (!yearObj) return 0;
    if (yearObj.turnoverRate !== undefined && yearObj.turnoverRate !== null) {
      return Number(yearObj.turnoverRate);
    }
    if (yearObj.turnover !== undefined && yearObj.turnover !== null) {
      return Number(yearObj.turnover);
    }
    if (yearObj.rate !== undefined && yearObj.rate !== null) {
      return Number(yearObj.rate);
    }
    if (yearObj.percentage !== undefined && yearObj.percentage !== null) {
      return Number(yearObj.percentage);
    }
    return 0;
  };

  const getRetentionValue = (yearObj) => {
    if (!yearObj) return 0;
    if (yearObj.retentionRate !== undefined && yearObj.retentionRate !== null) {
      return Number(yearObj.retentionRate);
    }
    if (yearObj.retention !== undefined && yearObj.retention !== null) {
      return Number(yearObj.retention);
    }
    if (yearObj.rate !== undefined && yearObj.rate !== null) {
      return Number(yearObj.rate);
    }
    if (yearObj.percentage !== undefined && yearObj.percentage !== null) {
      return Number(yearObj.percentage);
    }
    return 0;
  };

  // 4. Employee Turnover Rate
  const turnoverComp = getComponent("soc_employee_turnover");
  const turnoverCategories =
    activeDashboard === "live"
      ? ["Previous Year", "Current Year"]
      : ["2019", "2020", "2021", "2022", "2023"];

  const prevTurnoverVal =
    activeDashboard === "live"
      ? getTurnoverValue(turnoverComp?.data?.previousYear)
      : 12;
  const currTurnoverVal =
    activeDashboard === "live"
      ? getTurnoverValue(turnoverComp?.data?.currentYear)
      : 7;

  const turnoverLineData =
    activeDashboard === "live"
      ? [prevTurnoverVal, currTurnoverVal]
      : [12, 10, 9, 8, 7];

  const turnoverSeries =
    activeDashboard === "live"
      ? [
          {
            name: "Employee Count",
            type: "column",
            data: [
              turnoverComp?.data?.previousYear?.total || 0,
              turnoverComp?.data?.currentYear?.total || 0,
            ],
          },
          {
            name: "Turnover",
            type: "line",
            data: turnoverLineData,
          },
        ]
      : [
          {
            name: "Employee Count",
            type: "column",
            data: [480, 500, 540, 570, 598],
          },
          { name: "Turnover", type: "line", data: [12, 10, 9, 8, 7] },
        ];

  // 5. Retention Rate
  const retentionComp = getComponent("soc_retention_rate");
  const retentionCategories =
    activeDashboard === "live"
      ? ["Previous Year", "Current Year"]
      : ["2019", "2020", "2021", "2022", "2023"];

  const prevRetentionVal =
    activeDashboard === "live"
      ? getRetentionValue(retentionComp?.data?.previousYear)
      : 88;
  const currRetentionVal =
    activeDashboard === "live"
      ? getRetentionValue(retentionComp?.data?.currentYear)
      : 93;

  const retentionLineData =
    activeDashboard === "live"
      ? [prevRetentionVal, currRetentionVal]
      : [88, 90, 91, 92, 93];

  const retentionSeries =
    activeDashboard === "live"
      ? [
          {
            name: "Employee Count",
            type: "column",
            data: [
              retentionComp?.data?.previousYear?.total || 0,
              retentionComp?.data?.currentYear?.total || 0,
            ],
          },
          {
            name: "Retention Rate",
            type: "line",
            data: retentionLineData,
          },
        ]
      : [
          {
            name: "Employee Count",
            type: "column",
            data: [480, 500, 540, 570, 598],
          },
          { name: "Retention Rate", type: "line", data: [88, 90, 91, 92, 93] },
        ];

  // 6. % Change in Manpower
  const manpowerComp = getComponent("soc_manpower_change");
  const manpowerCategories = ["YOY Change"];
  const manpowerSeries =
    activeDashboard === "live"
      ? [manpowerComp?.data?.percentageChange || 0]
      : [4.91];

  // 7. Training & Development
  const trainingComp = getComponent("soc_training_development");
  const trainingCategories =
    activeDashboard === "live"
      ? ["Previous Year", "Current Year"]
      : ["2019", "2020", "2021", "2022", "2023"];
  const trainingData =
    activeDashboard === "live"
      ? [
          trainingComp?.data?.previousYear || 0,
          trainingComp?.data?.currentYear || 0,
        ]
      : [65, 50, 72, 78, 85];

  // 8. Diversity
  const diversityComp = getComponent("soc_diversity");
  const diversityLabels =
    activeDashboard === "live"
      ? diversityComp?.data?.labels || [
          "Male",
          "Female",
          "Other",
          "Specially Abled",
        ]
      : ["Female", "Male", "Other"];
  const diversityData =
    activeDashboard === "live"
      ? diversityComp?.data?.percentages || [0, 0, 0, 0]
      : [23.4, 75.3, 1.3];
  const totalDiversityCount =
    activeDashboard === "live" && diversityComp?.data?.total > 0 ? 100 : 0;
  const diversityColors =
    activeDashboard === "live"
      ? [THEME_COLORS.green, THEME_COLORS.yellow, "#0288A1", THEME_COLORS.pink]
      : [THEME_COLORS.green, THEME_COLORS.yellow, "#0288A1"];

  // 9. Gender Pay Equity
  const genderComp = getComponent("soc_gender_pay_equity");
  const genderLabels =
    activeDashboard === "live"
      ? genderComp?.data?.labels || ["Male", "Female"]
      : ["Female", "Male"];
  const genderData =
    activeDashboard === "live"
      ? genderComp?.data?.percentages || [0, 0]
      : [97, 100];

  // 10. Permanent & Other than permanent Workforce
  const workforceComp = getComponent("soc_permanent_workforce");
  const workforceSeries =
    activeDashboard === "live"
      ? [
          {
            name: "Female",
            data: [
              workforceComp?.data?.permanentFemale?.count || 0,
              workforceComp?.data?.otherFemale?.count || 0,
            ],
          },
          {
            name: "Male",
            data: [
              workforceComp?.data?.permanentMale?.count || 0,
              workforceComp?.data?.otherMale?.count || 0,
            ],
          },
        ]
      : [
          { name: "Female", data: [40, 50] },
          { name: "Male", data: [40, 60] },
        ];

  // Percentage values for workforce connector-line labels
  const workforcePercentageData =
    activeDashboard === "live"
      ? {
          female: [
            workforceComp?.data?.permanentFemale?.percentage ?? null,
            workforceComp?.data?.otherFemale?.percentage ?? null,
          ],
          male: [
            workforceComp?.data?.permanentMale?.percentage ?? null,
            workforceComp?.data?.otherMale?.percentage ?? null,
          ],
        }
      : { female: [15.38, 19.23], male: [15.38, 23.08] };

  // 11a. Permanent Vs Temporary Employees
  const permTempComp = getComponent("soc_permanent_vs_temporary");
  const permTempSeries =
    activeDashboard === "live"
      ? [
          {
            name: "Female",
            data: [
              permTempComp?.data?.permanentFemale?.count || 0,
              permTempComp?.data?.otherFemale?.count || 0,
            ],
          },
          {
            name: "Male",
            data: [
              permTempComp?.data?.permanentMale?.count || 0,
              permTempComp?.data?.otherMale?.count || 0,
            ],
          },
        ]
      : [
          { name: "Female", data: [700, 300] },
          { name: "Male", data: [80, 20] },
        ];

  // Percentage values for permanent vs temporary connector-line labels
  const permTempPercentageData =
    activeDashboard === "live"
      ? {
          female: [
            permTempComp?.data?.permanentFemale?.percentage ?? null,
            permTempComp?.data?.otherFemale?.percentage ?? null,
          ],
          male: [
            permTempComp?.data?.permanentMale?.percentage ?? null,
            permTempComp?.data?.otherMale?.percentage ?? null,
          ],
        }
      : { female: [89.74, 93.75], male: [10.26, 6.25] };

  // 12. Health & Safety training provided
  const hsTrainingComp = getComponent("soc_hs_training");
  const hsTrainingCategories = ["Previous Year", "Current Year"];
  const hsTrainingData =
    activeDashboard === "live"
      ? [
          hsTrainingComp?.data?.previousYear?.total || 0,
          hsTrainingComp?.data?.currentYear?.total || 0,
        ]
      : [80, 92.5];

  // 13. Incident reduced
  const incidentComp = getComponent("soc_incident_reduced");
  const incidentCategories = ["YOY Change"];
  const incidentData =
    activeDashboard === "live"
      ? [incidentComp?.data?.percentageChange || 0]
      : [-30];

  const calculateCleanMaxWithHeadroom = (maxVal, defaultMinMax = 100) => {
    if (!maxVal || maxVal <= 0) return defaultMinMax;
    const valWithHeadroom = maxVal * 1.25; // 25% extra headroom above max value

    if (valWithHeadroom >= 1000) {
      return Math.ceil(valWithHeadroom / 100) * 100;
    } else if (valWithHeadroom >= 100) {
      return Math.ceil(valWithHeadroom / 50) * 50;
    } else if (valWithHeadroom >= 10) {
      return Math.ceil(valWithHeadroom / 10) * 10;
    } else {
      return Math.ceil(valWithHeadroom);
    }
  };

  const calculateRightYAxisMax = (lineDataArray) => {
    const validVals = (lineDataArray || []).map((v) => Number(v) || 0);
    const maxVal = Math.max(...validVals, 0);
    if (maxVal <= 100) return 100;
    return calculateCleanMaxWithHeadroom(maxVal);
  };

  const rawTurnoverMax =
    activeDashboard === "live"
      ? Math.max(
          turnoverComp?.data?.previousYear?.total || 0,
          turnoverComp?.data?.currentYear?.total || 0,
        )
      : Math.max(...(turnoverSeries[0]?.data || [100]));
  const turnoverMax = calculateCleanMaxWithHeadroom(rawTurnoverMax, 100);
  const turnoverRightMax = calculateRightYAxisMax(turnoverLineData);

  const rawRetentionMax =
    activeDashboard === "live"
      ? Math.max(
          retentionComp?.data?.previousYear?.total || 0,
          retentionComp?.data?.currentYear?.total || 0,
        )
      : Math.max(...(retentionSeries[0]?.data || [100]));
  const retentionMax = calculateCleanMaxWithHeadroom(rawRetentionMax, 100);
  const retentionRightMax = calculateRightYAxisMax(retentionLineData);

  const trainingMax = calculateRightYAxisMax(trainingData);

  const workforceMax =
    activeDashboard === "live"
      ? Math.max(
          workforceComp?.data?.permanentFemale?.count || 0,
          workforceComp?.data?.permanentMale?.count || 0,
          workforceComp?.data?.otherFemale?.count || 0,
          workforceComp?.data?.otherMale?.count || 0,
          10,
        )
      : 100;

  const permTempMax =
    activeDashboard === "live"
      ? Math.max(
          permTempComp?.data?.permanentFemale?.count || 0,
          permTempComp?.data?.permanentMale?.count || 0,
          permTempComp?.data?.otherFemale?.count || 0,
          permTempComp?.data?.otherMale?.count || 0,
          1000,
        )
      : 1000;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#F5F5F5]">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#458276]"></div>
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-4 md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm permissionConClose={() => setPermission(false)} />
      )}
      <TimeFilterBar
        title="Social"
        showBreadcrumb={true}
        breadcrumbItems={["Home", "Social"]}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
        activeDashboard={activeDashboard}
        onDashboardChange={setActiveDashboard}
        onYearChange={setYearFilter}
        selectedYearValue={yearFilter}
      />

      <div
        className={`flex flex-col space-y-6 mt-2 ${
          !isPermissionCompleted ? "blur-sm opacity-20 pointer-events-none" : ""
        }`}
      >
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 justify-center">
          <div className="w-full sm:w-[48%] lg:w-[32%]">
            <CarbonCard
              icon={<Env1 />}
              title=" Local Communities"
              value={localCommValue}
              description="New hires from local communities."
              descriptionBgColor={THEME_COLORS.green}
              descriptionClassName="text-left"
              valueClassName="text-xl"
            />
          </div>
          <div className="w-full sm:w-[48%] lg:w-[32%]">
            <CarbonCard
              icon={<Env2 />}
              title="Local Suppliers"
              value={localSuppValue}
              description="Increase in procurement spent with local suppliers"
              descriptionBgColor={THEME_COLORS.green}
              descriptionClassName="text-left"
              valueClassName="text-xl"
            />
          </div>
          <div className="w-full sm:w-[48%] lg:w-[32%]">
            <CarbonCard
              icon={<Env3 />}
              title="Local Economic Empowerment"
              value={localEmpowerValue}
              description="Contribution to local economic empowerment initiatives"
              descriptionBgColor={THEME_COLORS.green}
              descriptionClassName="text-left"
              valueClassName="text-xl"
            />
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <Card
            title="Workforce Turnover Rate"
            Icon={EmployeeTurnoverRateImage}
          >
            <LineAndColumnGraph
              categories={turnoverCategories}
              seriesData={turnoverSeries}
              columnWidth="55%"
              graphWidth="75%"
              yAxisLeftConfig={{
                label: "Workforce Count",
                min: 0,
                max: turnoverMax,
                tickAmount: 10,
              }}
              yAxisRightConfig={{
                label: "Turnover (in %)",
                min: 0,
                max: turnoverRightMax,
                tickAmount: 10,
              }}
              showLegends
            />
          </Card>

          <Card title="Retention Rate" Icon={RetentionRateImage}>
            <LineAndColumnGraph
              categories={retentionCategories}
              seriesData={retentionSeries}
              columnWidth="55%"
              graphWidth="75%"
              yAxisLeftConfig={{
                label: "Workforce Count",
                min: 0,
                max: retentionMax,
                tickAmount: 10,
              }}
              yAxisRightConfig={{
                label: "Retention (in %)",
                min: 0,
                max: retentionRightMax,
                tickAmount: 10,
              }}
              showLegends
            />
          </Card>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <Card
            title="Percentage Change In Manpower"
            Icon={ChangeInManPowerImage}
          >
            <ColumnWithNegativeVal
              title="Annual Growth Analysis"
              categories={manpowerCategories}
              seriesData={manpowerSeries}
              colors={columnColors}
              seriesName="Percentage Change In Manpower"
            />
          </Card>

          <Card title="Training & Development" Icon={TrainingAndDevelopImage}>
            <div className="flex flex-col items-end pr-6 mt-2 mb-2">
              <div className="flex items-center w-32">
                <span className="h-3 w-3 bg-[#06513D] rounded-full border" />
                <div className="flex-grow border-t-2 border-[#06513D]" />
                <span className="h-3 w-3 bg-[#06513D] rounded-full border" />
              </div>
              <p className="text-xs text-[#06513D] mt-1">
                % of Employee Trained
              </p>
            </div>
            <LineChart
              data={trainingData}
              categories={trainingCategories}
              legend="Training Participation"
              yAxisConfig={{
                label: "Percentage of employee training",
                min: 0,
                max: trainingMax,
                tickAmount: 10,
              }}
            />
          </Card>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <Card title="Diversity" Icon={DiversityImage}>
            <SimplePieChart
              data={diversityData}
              labels={diversityLabels}
              colors={diversityColors}
              width={320}
              isDonut
              shows
              legendPosition="right"
              totalValue={totalDiversityCount}
            />
          </Card>

          <Card title="Gender Pay Equity" Icon={GenderPayEquityImage}>
            <SimplePieChart
              data={genderData}
              labels={genderLabels}
              colors={[THEME_COLORS.green, THEME_COLORS.yellow, "#0288A1"]}
              width={320}
              legendPosition="right"
              options={{
                plotOptions: {
                  pie: {
                    dataLabels: {
                      offset: -40,
                      minAngleToShowLabel: 10,
                    },
                  },
                },
              }}
            />
          </Card>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <Card
            title="Permanent & Other than permanent Workforce"
            Icon={EmpWorkContractImage}
          >
            <WorkforceBarChart
              categories={[
                ["Permanent", "workforce"],
                ["Other than", "Permanent workforce"],
              ]}
              seriesData={workforceSeries}
              percentageData={workforcePercentageData}
              yAxisLeftConfig={{ min: 0, max: workforceMax, tickAmount: 10 }}
              yAxisRightConfig={{ min: 0, max: 100, tickAmount: 10 }}
              colors={[THEME_COLORS.pink, THEME_COLORS.green]}
            />
          </Card>

          <Card
            title="Permanent Vs Temporary Employees"
            Icon={PermVSTempEmpImage}
          >
            <WorkforceBarChart
              categories={[
                ["Permanent", "Employees"],
                ["Temporary", "Employees"],
              ]}
              seriesData={permTempSeries}
              percentageData={permTempPercentageData}
              yAxisLeftConfig={{ min: 0, max: permTempMax, tickAmount: 10 }}
              yAxisRightConfig={{ min: 0, max: 100, tickAmount: 10 }}
              colors={[THEME_COLORS.pink, THEME_COLORS.green]}
            />
          </Card>
        </div>

        <div className="w-full bg-white rounded-lg border border-[#3BA2B959] shadow-md pt-5">
          <HealthAndSafetty
            getComponent={getComponent}
            activeDashboard={activeDashboard}
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <HSSafetyTrainingCard
            hsTrainingComp={hsTrainingComp}
            activeDashboard={activeDashboard}
            Icon={TitleIcon}
          />

          <div className="bg-white rounded-lg border border-[#3BA2B959] shadow-md pt-5 flex flex-col justify-start">
            <EmployeeWellBeing
              getComponent={getComponent}
              activeDashboard={activeDashboard}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Card
            title="Incident Increased / Reduced"
            Icon={IncidentReducedImage}
          >
            <ColumnWithNegativeVal
              title="Incident Increased / Reduced"
              categories={incidentCategories}
              seriesData={incidentData}
              colors={columnColors}
              seriesName="Incident Increased / Reduced"
            />
          </Card>

          <div className="bg-white rounded-lg border border-[#3BA2B959] shadow-md pt-5 flex flex-col">
            <EmployementEngagement
              getComponent={getComponent}
              activeDashboard={activeDashboard}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Card = ({ title, Icon, children }) => (
  <div className="flex-1 bg-white rounded-lg border border-[#3BA2B959] shadow-md pt-5 flex flex-col">
    <div className="flex items-start gap-3 px-4 min-h-[56px]">
      {Icon && (
        <div className="flex-shrink-0 flex items-center justify-center pt-0.5">
          <Icon className="w-13 h-13" />
        </div>
      )}
      <div
        className="flex items-start flex-1 pt-1 capitalize"
        style={{ color: THEME_COLORS.green }}
      >
        <p className="text-lg font-semibold leading-snug m-0">{title}</p>
      </div>
    </div>
    <div
      className="px-4 py-4 overflow-x-auto flex-1 flex flex-col justify-end"
      style={{ color: THEME_COLORS.green }}
    >
      {children}
    </div>
  </div>
);

const UserGroupIcon = ({ color = "#06513D" }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const HSSafetyTrainingCard = ({ hsTrainingComp, activeDashboard, Icon }) => {
  const previousTotal =
    activeDashboard === "live"
      ? (hsTrainingComp?.data?.previousYear?.total ?? 0)
      : 20;

  const currentTotal =
    activeDashboard === "live"
      ? (hsTrainingComp?.data?.currentYear?.total ?? 0)
      : 40;

  const percentageChange =
    activeDashboard === "live"
      ? (hsTrainingComp?.data?.percentageChange ?? 0)
      : 100;

  const changeValue = Math.abs(percentageChange);
  const isPositive = percentageChange >= 0;

  return (
    <div className="flex-1 bg-white rounded-lg border border-[#3BA2B959] shadow-md p-5 flex flex-col justify-start min-h-[420px]">
      {/* Header */}
      <div className="flex items-center gap-2">
        <Icon className="w-13 h-13" />
        <div style={{ color: THEME_COLORS.green }}>
          <p className="text-[18px] sm:text-[20px] font-[Calibri] font-bold tracking-normal leading-tight m-0">
            Health &amp; Safety Training Provided
          </p>
        </div>
      </div>

      <div className="flex-1 flex flex-col justify-center gap-6 mt-0">
        {/* Percentage change display */}
        <div className="flex flex-col items-center justify-center mb-4">
          <div
            className="flex items-center text-4xl sm:text-5xl font-extrabold"
            style={{ color: isPositive ? "#06513D" : "#c0392b" }}
          >
            <span>{isPositive ? "↑" : "↓"}</span>
            <span className="ml-1">{parseFloat(changeValue.toFixed(2))}%</span>
          </div>
          <p className="text-xs text-black font-medium m-0 mt-1">
            Compared with Previous Year
          </p>
        </div>

        {/* Boxes with Arrow */}
        <div className="flex items-center justify-center gap-2 sm:gap-4 md:gap-6 pb-2">
          {/* Previous Year Box */}
          <div className="relative pt-3 w-1/2 max-w-[180px] sm:max-w-[220px]">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 px-3 py-0.5 rounded text-[10px] sm:text-xs font-bold text-white bg-[#06513D] shadow-sm whitespace-nowrap">
              Previous Year
            </div>
            <div className="bg-[#F4FAF8] border border-[#E1EEEC] rounded-2xl p-4 pt-8 sm:p-5 sm:pt-9 flex flex-col items-center justify-center">
              <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full flex items-center justify-center bg-[#E5ECEB] mb-2 sm:mb-3">
                <UserGroupIcon color="#06513D" />
              </div>
              <div className="text-3xl sm:text-4xl font-extrabold text-[#06513D] leading-none mb-1">
                {previousTotal}
              </div>
              <div className="text-[11px] sm:text-xs font-semibold text-black font-calibri">
                Employees
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex items-center justify-center pt-3">
            <svg
              className="w-6 h-6 sm:w-8 sm:h-8 text-[#06513D]"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </div>

          {/* Current Year Box */}
          <div className="relative pt-3 w-1/2 max-w-[180px] sm:max-w-[220px]">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 px-3 py-0.5 rounded text-[10px] sm:text-xs font-bold text-white bg-[#E2A928] shadow-sm whitespace-nowrap">
              Current Year
            </div>
            <div className="bg-[#FFFDF4] border border-[#FFF0CB] rounded-2xl p-4 pt-8 sm:p-5 sm:pt-9 flex flex-col items-center justify-center">
              <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full flex items-center justify-center bg-[#FFF1CD] mb-2 sm:mb-3">
                <UserGroupIcon color="#06513D" />
              </div>
              <div className="text-3xl sm:text-4xl font-extrabold text-[#06513D] leading-none mb-1">
                {currentTotal}
              </div>
              <div className="text-[11px] sm:text-xs font-semibold text-black font-calibri">
                Employees
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Social;
